import { Content } from 'components/Content';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { SEO } from 'components/SEO';
import { ScreenClassProvider } from 'react-grid-system';

function App() {
  return (
    <ScreenClassProvider>
      <SEO />
      <Header />
      <Content />
      <Footer />
    </ScreenClassProvider>
  );
}

export default App;
